import React from 'react';
import { useCss } from 'react-use';
import cn from 'classnames';

import { useTheme } from 'providers/Theme.provider';

import CN from './PieChart.module.scss';

const PieChart = ({ activeServices, allServices }) => {
  const { isDarkMode } = useTheme();

  const active = (activeServices / allServices) * 100;
  const inactive = 100 - active;

  const pieStyle = useCss({
    background: `conic-gradient(
        #8e06bf 0% ${active}%, 
        #e8e8e8 ${active}% 
        ${inactive}%
    )`,
  });

  return (
    <div
      data-bem="PieChart"
      className={cn({
        [CN.component]: true,
        [CN.darkMode]: isDarkMode,
      })}
    >
      <div
        className={cn({
          [CN.pie]: true,
          [pieStyle]: pieStyle,
        })}
      >
        <div className={CN.pieInnerCircle} />
      </div>
      <div>
        {activeServices} / {allServices}
      </div>
    </div>
  );
};

export default PieChart;
